import MuiBottomNavigationAction from '@mui/material/BottomNavigationAction';
import patchButtonBaseComponent from './patch-base-button-components';
export const BottomNavigationAction = patchButtonBaseComponent(MuiBottomNavigationAction);
